import { VagasPorCategoria } from '../services/torneioService';

export type VagasStatus = 'unlimited' | 'available' | 'waitlist' | 'full';

export interface VagasInfo {
  vagasDisponiveis: number | null;
  ocupadas: number;
  status: VagasStatus;
}

/**
 * Computes vagas availability for a tournament category using pre-computed counts.
 *
 * Effective waitlist rule (mirrors backend InscricaoTorneioService.filaEsperaEfetiva):
 *   configFilaEspera (non-null) → category override wins
 *   configFilaEspera null       → falls back to torneio.filaEspera
 *
 * @param categoriaId - The category ID to check
 * @param vagas - The total number of slots (null/undefined = unlimited)
 * @param contagemVagas - Pre-computed counts of occupied slots per category
 * @param filaEspera - Tournament-level waitlist flag (falsy = no waitlist)
 * @param configFilaEspera - Category-level override (null = inherit from tournament)
 * @returns VagasInfo with available slots count and status
 */
export function getVagasInfo(
  categoriaId: string,
  vagas: number | undefined | null,
  contagemVagas: VagasPorCategoria[],
  filaEspera: boolean | undefined | null,
  configFilaEspera?: boolean | null
): VagasInfo {
  const entry = contagemVagas.find((c) => c.categoriaId === categoriaId);
  const ocupadas = entry?.ocupadas ?? 0;

  if (vagas == null) return { vagasDisponiveis: null, ocupadas, status: 'unlimited' };

  const disponiveis = Math.max(vagas - ocupadas, 0);
  if (disponiveis > 0) return { vagasDisponiveis: disponiveis, ocupadas, status: 'available' };

  const filaEsperaEfetiva = configFilaEspera != null ? configFilaEspera : (filaEspera ?? false);
  if (filaEsperaEfetiva) return { vagasDisponiveis: 0, ocupadas, status: 'waitlist' };
  return { vagasDisponiveis: 0, ocupadas, status: 'full' };
}
